module.exports = __webpack_public_path__ + "static/img/17.3d9537e6.png";